import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getProjectHeatmapSettings } from "slices/projectHeatmapSettings/projectHeatmapSettingsSlice";

export const defaultMinClustersCount = 8;
const defaultMinClusterSquareSize = 10;
const defaultMaxDefaultClustersCount = 29;

export interface SelectedClusteringState {
  selectedClustering: number;
  isClusteringEnabled: boolean;
  minClusterSquareSize: number;
  maxDefaultClustersCount: number;
}

const initialState = {
  selectedClustering: 12,
  isClusteringEnabled: false,
  minClusterSquareSize: defaultMinClusterSquareSize,
  maxDefaultClustersCount: defaultMaxDefaultClustersCount,
} as SelectedClusteringState;

interface SetClusterSettingsPayload {
  imageHeight: number;
  imageWidth: number;
}

const selectedClusteringSlice = createSlice({
  name: "selectedClustering",
  initialState: initialState,
  reducers: {
    resetSelectedClustering: () => initialState,
    setSelectedClustering: (state, action: PayloadAction<number>) => {
      state.selectedClustering = action.payload;
    },
    setIsClusteringEnabled: (state, action: PayloadAction<boolean>) => {
      state.isClusteringEnabled = action.payload;
    },
    setClusterSettings: (state, action: PayloadAction<SetClusterSettingsPayload>) => {
      state.maxDefaultClustersCount = Math.floor(
        Math.min(action.payload.imageHeight, action.payload.imageWidth) / defaultMinClusterSquareSize,
      );
      const defaultClustering = Math.floor(
        Math.min(action.payload.imageHeight, action.payload.imageWidth) / defaultMinClusterSquareSize,
      );
      if (state.selectedClustering > defaultClustering) {
        state.selectedClustering = defaultClustering;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectHeatmapSettings.fulfilled, (state, action) => {
      const { selectedClustering } = action.payload.projectSettings;
      return selectedClustering ?? initialState;
    });
  },
});

export const { setSelectedClustering, setIsClusteringEnabled, setClusterSettings, resetSelectedClustering } =
  selectedClusteringSlice.actions;

export default selectedClusteringSlice.reducer;
